import { useEffect } from "react";
import Download from "../../components/Download/index.js";
import "./index.css";
import { downloadData } from "../../downloadData.js";

const DownloadPage = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = downloadData.ios.downloadLink;
    } else if (/android/i.test(userAgent)) {
      window.location.href = downloadData.android.downloadLink;
    }
  }, []);

  return (
    <div className="download-page">
      <Download />
    </div>
  );
};

export default DownloadPage;
